import { Injectable } from '@angular/core';
import { LoaderComponent } from './loader.component';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderComponent?: LoaderComponent;

  add(loaderComponent: LoaderComponent) {
    this.loaderComponent = loaderComponent;
  }

  show() {
    console.log(`[show] [this.loaderComponent=${this.loaderComponent}]`)
    this.loaderComponent?.show()
  }

  hide() {
    this.loaderComponent?.hide();
  }
}
